"use client"

import { useRef, useEffect, useState } from "react"
import styles from "./Home.module.css"
import Swal from "sweetalert2"
import "bootstrap/dist/css/bootstrap.min.css"
import ModalTratDatos from "./modal"
import Slider from "../components/Slider/Slider"
import TeamHover from "../components/Grupo_trabajo/Grupo_trabajo"
import { servicesData } from "../data/services-data"
import ServiciosLegalesSection from "../components/ServiciosLegales"
import { useNavigate } from "react-router-dom"
import Info from "../components/Contacto_info/Contacto_info"
import Frecuentes from "../components/Faq_component/FAQComponent"

export default function Home() {
  const [showDataModal, setShowDataModal] = useState(false)
  const [dataChecked, setDataChecked] = useState(false)
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [showFamilyForm, setShowFamilyForm] = useState(false)
  const [isFlipping, setIsFlipping] = useState(false)
  const [showScroll, setShowScroll] = useState(false)
  const [currentIndex, setCurrentIndex] = useState(0)
  const [servicesPerView, setServicesPerView] = useState(3)
  const footerRef = useRef(null)

  const [showTooltip, setShowTooltip] = useState(false)
  const [initialTooltip, setInitialTooltip] = useState(true)

  // Referencias para navegación
  const inicioRef = useRef(null)
  const serviciosLegalesRef = useRef(null)
  const serviciosRef = useRef(null)
  const equipoRef = useRef(null)
  const preguntasRef = useRef(null)
  const infoRef = useRef(null)

  const navigate = useNavigate()

  const [contactData, setContactData] = useState({
    email: "",
    nombre: "",
    apellidos: "",
    tipoDoc: "",
    numDoc: "",
    email2: "",
    direccion: "",
    celular: "",
    dataChecked: false,
    policyChecked: false,
  })

  const [familyData, setFamilyData] = useState({
    email: "",
    nombre: "",
    apellidos: "",
    tipoDoc: "",
    numDoc: "",
    lugarDefuncion: "",
    parentesco: "",
  })

  const handleQuienesSomosClick = () => {
    navigate("/Quienes")
    setIsMenuOpen(false)
  }

  // Función para scroll a secciones - mejorada
  const scrollToSection = (sectionRef) => {
    if (sectionRef && sectionRef.current) {
      const elementPosition = sectionRef.current.offsetTop
      const offsetPosition = elementPosition - 100 // Ajuste para header fijo

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      })
    }
  }

  // Funciones específicas para navegación del header
  const scrollToServiciosLegales = () => {
    scrollToSection(serviciosLegalesRef)
    setIsMenuOpen(false)
  }

  const scrollToServicios = () => {
    scrollToSection(serviciosRef)
    setIsMenuOpen(false)
  }

  const scrollToEquipo = () => {
    scrollToSection(equipoRef)
    setIsMenuOpen(false)
  }

  const scrollToPreguntas = () => {
    scrollToSection(preguntasRef)
    setIsMenuOpen(false)
  }

  const scrollToInfo = () => {
    scrollToSection(infoRef)
    setIsMenuOpen(false)
  }

  const scrollToInicio = () => {
    scrollToSection(inicioRef)
    setIsMenuOpen(false)
  }

  const isElementInViewport = (el) => {
    const rect = el.getBoundingClientRect()
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    )
  }

  const handleScroll = () => {
    const images = document.querySelectorAll(`.${styles.serviceImage}, .${styles.projectImage}`)
    const contents = document.querySelectorAll(`.${styles.serviceContent}, .${styles.projectContent}`)

    images.forEach((img) => {
      if (isElementInViewport(img) && !img.classList.contains(styles.animateLeft)) {
        img.classList.add(styles.animateLeft)
      }
    })

    contents.forEach((content) => {
      if (isElementInViewport(content) && !content.classList.contains(styles.animateRight)) {
        content.classList.add(styles.animateRight)
      }
    })
  }

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setServicesPerView(1)
      } else if (window.innerWidth < 1024) {
        setServicesPerView(2)
      } else {
        setServicesPerView(3)
      }
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + servicesPerView >= servicesData.length ? 0 : prev + servicesPerView))
  }

  const prevSlide = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? Math.max(0, servicesData.length - servicesPerView) : Math.max(0, prev - servicesPerView),
    )
  }

  useEffect(() => {
    if (isMenuOpen) {
      document.body.classList.add(styles.menuOpen)
    } else {
      document.body.classList.remove(styles.menuOpen)
    }

    return () => {
      document.body.classList.remove(styles.menuOpen)
      setInitialTooltip(true)

      const timer = setTimeout(() => {
        setInitialTooltip(false)
      }, 5000)

      return () => clearTimeout(timer)
    }
  }, [isMenuOpen])

  const scrollToTop = () => {
    const duration = 2000
    const start = window.pageYOffset
    const startTime = "now" in window.performance ? performance.now() : new Date().getTime()

    const scroll = () => {
      const now = "now" in window.performance ? performance.now() : new Date().getTime()
      const time = Math.min(1, (now - startTime) / duration)
      const easeInOutCubic = time < 0.5 ? 4 * time * time * time : (time - 1) * (2 * time - 2) * (2 * time - 2) + 1

      window.scrollTo(0, start * (1 - easeInOutCubic))

      if (time < 1) {
        requestAnimationFrame(scroll)
      }
    }

    requestAnimationFrame(scroll)
  }

  useEffect(() => {
    const checkScrollTop = () => {
      if (!footerRef.current) return

      const footerPosition = footerRef.current.getBoundingClientRect().top
      const windowHeight = window.innerHeight

      setShowScroll(window.pageYOffset > 400 && footerPosition > windowHeight + 100)
    }

    window.addEventListener("scroll", checkScrollTop)
    return () => window.removeEventListener("scroll", checkScrollTop)
  }, [])

  useEffect(() => {
    window.addEventListener("scroll", handleScroll)
    window.addEventListener("load", handleScroll)

    return () => {
      window.removeEventListener("scroll", handleScroll)
      window.removeEventListener("load", handleScroll)
    }
  }, [])

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  const visibleServices = servicesData.slice(currentIndex, currentIndex + servicesPerView)

  const handleSubmit = (e) => {
    e.preventDefault()
    Swal.fire({
      title: "Datos enviados exitosamente",
      text: "Por favor llenar los datos de familiar",
      icon: "success",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      background: "#d7e3df",
      iconColor: "#07593B",
    }).then(() => {
      setIsFlipping(true)
      setTimeout(() => {
        setShowFamilyForm(true)
        setTimeout(() => {
          setIsFlipping(false)
        }, 500)
      }, 300)
    })
  }

  const handleFamilySubmit = (e) => {
    e.preventDefault()
    console.log("Datos de la familia:", familyData)
  }

  const handleContactChange = (e) => {
    const { name, value } = e.target
    setContactData((prevState) => ({ ...prevState, [name]: value }))
  }

  const handleFamilyChange = (e) => {
    const { name, value } = e.target
    setFamilyData((prevState) => ({ ...prevState, [name]: value }))
  }

  return (
    <div className={styles.layeredContainer}>
      {/* CAPA 0 - FONDO CON IMAGEN GRANDE Y LOGO CENTRADO */}
      <div className={styles.backgroundLogoLayer}>
        {/* Imagen de fondo grande que cubre toda la pantalla */}
        <img
          src={require("../assets/fondo_8.png") || "/placeholder.svg"}
          alt="Fondo principal"
          className={styles.backgroundFullImage}
        />

        {/* Logo centrado sobre la imagen de fondo */}
        <div className={styles.backgroundLogoContainer}>
          <img
            src={require("../assets/defensa2.png") || "/placeholder.svg"}
            alt="Logo de fondo"
            className={styles.backgroundLogo}
          />
        </div>
      </div>

      {/* CAPA 1 - CONTENIDO PRINCIPAL */}
      <div className={styles.mainContentLayer}>
        <div className={styles.homeContainer}>
          {/* SLIDER - Sección de inicio */}
          <section id="inicio" ref={inicioRef}>
            <Slider id="slider" autoPlay={true} autoPlayInterval={6000} />
          </section>

          {/* SERVICIOS LEGALES DETALLADOS - Nueva sección */}
          <section id="servicios-legales" ref={serviciosLegalesRef}>
            <ServiciosLegalesSection />
          </section>

          {/* EQUIPO - Sección del equipo */}
          <section id="equipo" ref={equipoRef} className={styles.teamSection}>
            <TeamHover />
          </section>

          {/* Información adicional */}
          <section id="info" ref={infoRef}>
            <Info />
          </section>

          {/* PREGUNTAS FRECUENTES - Sección de FAQ */}
          <section id="preguntas" ref={preguntasRef}>
            <Frecuentes />
          </section>

          {/* CONTACTO - Sección de contacto */}
          <section id="contacto1" className={styles.banner}>
            <div className={styles.bannerContainer}>
              <div className={styles.bannerLogo}>
                <img
                  src={require("../assets/defensa2.png") || "/placeholder.svg"}
                  alt="Logo"
                  className={`${styles.imagen} ${styles.bannerLogoImg}`}
                />
              </div>

              <div className={styles.formulario}>
                <h3 className={styles.formTitle}>
                  {showFamilyForm ? "Formulario datos del familiar" : "Formulario datos de contacto"}
                </h3>
                <div className={styles.formContainer}>
                  <div className={`${styles.formFlipper} ${isFlipping ? styles.flipping : ""}`}>
                    <div className={`${styles.formContent} ${showFamilyForm ? styles.back : styles.front}`}>
                      {!showFamilyForm ? (
                        <form onSubmit={handleSubmit} className={styles.contactForm}>
                          {/* <h3 className={styles.formSubtitle}>Datos de contacto</h3> */}
                          <div className={styles.formGroup}>
                            <input
                              type="text"
                              name="nombre"
                              placeholder="Nombre"
                              required
                              value={contactData.nombre}
                              onChange={handleContactChange}
                            />
                          </div>
                          <div className={styles.formGroup}>
                            <input
                              type="text"
                              name="apellidos"
                              placeholder="Apellidos"
                              required
                              value={contactData.apellidos}
                              onChange={handleContactChange}
                            />
                          </div>
                          <div className={styles.formGroup}>
                            <select name="tipoDoc" required value={contactData.tipoDoc} onChange={handleContactChange}>
                              <option value="">Documento de Identificación</option>
                              <option value="cc">C.C</option>
                              <option value="ti">T.I</option>
                              <option value="ce">C.E</option>
                            </select>
                          </div>
                          <div className={styles.formGroup}>
                            <input
                              type="text"
                              name="numDoc"
                              placeholder="Número del documento"
                              required
                              value={contactData.numDoc}
                              onChange={handleContactChange}
                            />
                          </div>
                          <div className={styles.formGroup}>
                            <input
                              type="email"
                              name="email2"
                              placeholder="Correo electrónico"
                              required
                              value={contactData.email2}
                              onChange={handleContactChange}
                            />
                          </div>
                          <div className={styles.formGroup}>
                            <input
                              type="text"
                              name="direccion"
                              placeholder="Dirección"
                              required
                              value={contactData.direccion}
                              onChange={handleContactChange}
                            />
                          </div>
                          <div className={styles.formGroup}>
                            <input
                              type="tel"
                              name="celular"
                              placeholder="Número de celular"
                              required
                              value={contactData.celular}
                              onChange={handleContactChange}
                            />
                          </div>

                          <div className={styles.termsContainer}>
                            <input
                              type="checkbox"
                              id="termsCheckbox"
                              checked={dataChecked}
                              onChange={() => setDataChecked(!dataChecked)}
                            />
                            <label htmlFor="termsCheckbox" className={styles.termsLabel}>
                              <span className={styles.termsLink} onClick={() => setShowDataModal(true)}>
                                {" "}
                                Acepto el tratamiento de datos
                              </span>
                            </label>

                            <button
                              type="button"
                              className={styles.infoButton}
                              onMouseEnter={() => setShowTooltip(true)}
                              onMouseLeave={() => setShowTooltip(false)}
                            >
                              <svg
                                width="16"
                                height="16"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <circle cx="12" cy="12" r="10" stroke="#07593B" strokeWidth="2" />
                                <path d="M12 16v-4" stroke="#07593B" strokeWidth="2" strokeLinecap="round" />
                                <path d="M12 8h.01" stroke="#07593B" strokeWidth="2" strokeLinecap="round" />
                              </svg>
                            </button>

                            {(initialTooltip || showTooltip) && (
                              <div className={styles.customTooltip}>
                                <div className={styles.tooltipContent}>Debes aceptar los términos para continuar</div>
                                <div className={styles.tooltipArrow}></div>
                              </div>
                            )}
                          </div>
                          <button type="submit" className={styles.formButton} disabled={!dataChecked}>
                            Enviar
                          </button>
                        </form>
                      ) : (
                        <form onSubmit={handleFamilySubmit} className={styles.familyForm}>
                          <h3 className={styles.formSubtitle}>Datos del familiar</h3>
                          <div className={styles.formGroup}>
                            <input
                              type="email"
                              name="email"
                              placeholder="Correo"
                              required
                              value={familyData.email}
                              onChange={handleFamilyChange}
                            />
                          </div>
                          <div className={styles.formGroup}>
                            <input
                              type="text"
                              name="nombre"
                              placeholder="Nombre del familiar"
                              required
                              value={familyData.nombre}
                              onChange={handleFamilyChange}
                            />
                          </div>
                          <div className={styles.formGroup}>
                            <input
                              type="text"
                              name="apellidos"
                              placeholder="Apellidos del familiar"
                              required
                              value={familyData.apellidos}
                              onChange={handleFamilyChange}
                            />
                          </div>
                          <div className={styles.formGroup}>
                            <select name="tipoDoc" required value={familyData.tipoDoc} onChange={handleFamilyChange}>
                              <option value="">Documento de Identificación</option>
                              <option value="cc">C.C</option>
                              <option value="ti">T.I</option>
                              <option value="ce">C.E</option>
                            </select>
                          </div>
                          <div className={styles.formGroup}>
                            <input
                              type="text"
                              name="numDoc"
                              placeholder="Número del documento"
                              required
                              value={familyData.numDoc}
                              onChange={handleFamilyChange}
                            />
                          </div>
                          <div className={styles.formGroup}>
                            <input
                              type="text"
                              name="lugarDefuncion"
                              placeholder="Lugar de defunción"
                              required
                              value={familyData.lugarDefuncion}
                              onChange={handleFamilyChange}
                            />
                          </div>
                          <div className={styles.formGroup}>
                            <select
                              name="parentesco"
                              required
                              value={familyData.parentesco}
                              onChange={handleFamilyChange}
                            >
                              <option value="">Parentesco</option>
                              <option value="hijo">Hijo</option>
                              <option value="conyuge">Cónyuge supérstite</option>
                              <option value="hermano">Hermano</option>
                              <option value="padre">Padre</option>
                              <option value="otro">Otro</option>
                            </select>
                          </div>

                          <button type="submit" className={styles.formButton}>
                            Enviar
                          </button>
                        </form>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <ModalTratDatos showDataModal={showDataModal} setShowDataModal={setShowDataModal} />
          <div className={`${styles.scrollToTop} ${showScroll ? styles.visible : styles.hidden}`} onClick={scrollToTop}>
            <i className={`${styles.arrow} ${styles.up}`}></i>
          </div>
        </div>
      </div>
    </div>
  )
}
